module.exports = __webpack_public_path__ + "img/yl.6b67d7a7.svg";